import { render, staticRenderFns } from "./PrivateLayout.vue?vue&type=template&id=2beb57c7&"
import script from "./PrivateLayout.vue?vue&type=script&lang=js&"
export * from "./PrivateLayout.vue?vue&type=script&lang=js&"
import style0 from "./PrivateLayout.vue?vue&type=style&index=0&id=2beb57c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports